<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full"
  (click)="edit()"
  (focus)="edit()"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
    >
      {{ fieldDef.label }}
    </span>
  </mat-label>
  <div class="w-full">
    <textarea
      matInput
      [ngClass]="{ readonly: readonly }"
      #inputControl
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="500"
      [(ngModel)]="value"
      [maxLength]="10000"
      [disabled]="isDisabled"
      [spellcheck]="false"
      (blur)="onBlur()"
      [class.blurred]="fieldDef.meta?.value_hidden && !editing"
    ></textarea>
    @if (value && value.length > 0 && !fieldDef.meta?.value_hidden) {
      <p class="text-sm text-gray-500 text-right">Characters: {{ value.length }} / 10000</p>
    }
  </div>
</mat-form-field>
